import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import './styles.scss';
import LocalModal from 'components/base/local-modal';
import SelectDropdown from 'components/base/select-dropdown';
import useDashboardContext from 'contexts/dashboard.context';
import CurrencyInput from 'components/base/currency-input';
import { handleApiError } from 'utils/functions';
import { MemberListType } from 'models/member.model';

export type UpdateMemberPayload = { budget: string; budgetDuration: string; budgetSetting: string };

type Props = {
  isOpen: boolean;
  onClose: () => void;
  selectedPeople?: MemberListType[];
  setSelectedPeople?: (value: MemberListType[]) => void;
  updateMembers: (val: UpdateMemberPayload) => void;
};
const budgetDurationOptions = [
  { name: 'Daily', id: 'Daily' },
  { name: 'Weekly', id: 'Weekly' },
  { name: 'Monthly', id: 'Monthly' }
];
const BudgetSettingModal = ({
  isOpen,
  onClose,
  selectedPeople,
  setSelectedPeople,
  updateMembers
}: Props) => {
  const [budgetDuration, setBudgetDuration] = useState('');
  const [budgetSetting, setBudgetSetting] = useState('');
  const [budget, setBudget] = useState('');
  const [loading, setLoading] = useState(false);
  const { activeCompany } = useDashboardContext();
  const companyId: string = activeCompany?.id;
  const options = [
    {
      text: 'Set budget to one-off',
      subtext: 'I know a text explanation should go here',
      onClick: () => setBudgetSetting('ONE OFF'),
      name: 'ONE OFF'
    },
    {
      text: 'Set budget to roll-over',
      subtext: 'I know a text explanation should go here',
      onClick: () => setBudgetSetting('ROLL OVER'),
      name: 'ROLL OVER'
    }
  ];

  const handleBudgetSettings = async () => {
    if (!companyId) return;
    setLoading(true);
    const data = selectedPeople?.map((item) => {
      return {
        department_id: item.department_id,
        role: item.role,
        budget,
        budget_duration: budgetDuration,
        budget_setting: budgetSetting,
        member_id: item.id,
        company_id: item.company_id
      };
    });

    try {
      const res = await apiService.put('member/update/bulk', { data });
      if (res.status === 200) {
        toast(
          <ToastMessage
            type='success'
            message={`Budget setting for ${selectedPeople?.length} people updated successfully`}
          />
        );
        updateMembers({ budget, budgetDuration, budgetSetting });
      } else {
        toast(
          <ToastMessage
            type='error'
            message={`Budget setting for ${selectedPeople?.length} people failed`}
          />
        );
      }
      setSelectedPeople?.([]);
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  useEffect(() => {
    setBudget('');
    setBudgetDuration('');
    setBudgetSetting('');
  }, [isOpen]);

  return (
    <LocalModal title='Set Budget' isOpen={isOpen} onRequestClose={onClose}>
      <div className='flex flex-col gap-4'>
        <div className='flex gap-4 mt-2'>
          <div className='w-[50%] mt-[7px]'>
            <CurrencyInput
              label='Set a budget'
              placeholder='50,000'
              decimalsLimit={2}
              onChange={(v) => setBudget(v)}
              error=''
              className={`w-full h-[46px] z-1 relative focus:outline-none border-b-2 border-[#D5D6D7] py-3  pl-[14px]`}
            />
          </div>
          <div className='w-[50%]'>
            <SelectDropdown
              label='Budget Duration'
              value={budgetDuration}
              setValue={(option) => {
                setBudgetDuration(option.name);
              }}
              placeholder='Weekly'
              options={budgetDurationOptions}
            />
          </div>
        </div>
        <div className='flex flex-col gap-4'>
          {options.map(({ text, subtext, name, onClick }, index) => (
            <div
              key={index}
              className='flex justify-between mb-2 border items-center border-[#EFF0F0] px-4 rounded py-3 cursor-pointer'
              onClick={() => onClick()}>
              <div>
                <p className='font-medium text-sm '>{text}</p>
                <p className='text-xs text-[#6F7376] '>{subtext}</p>
              </div>
              <Input
                type='radio'
                className='text-sm border rounded-full border-gray-100'
                checked={budgetSetting === name}
                readOnly
              />
            </div>
          ))}
        </div>
        <div className='mt-6 flex justify-end items-center gap-4 modal_btn_box'>
          <Button
            variant='block'
            color='gray'
            className='w-[139px] rounded-[100px] h-[41px] gray_btn'
            onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            disabled={!budgetSetting || !budget || !budgetDuration}
            className='w-[139px] rounded-[100px] h-[41px]'
            onClick={() => handleBudgetSettings()}
            loading={loading}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default BudgetSettingModal;
